import React from 'react'
import { GoogleAd } from '../components/ads/GoogleAd'
import InterviewScoresPage from './InterviewScoresPage'
import FullScreenWrapper from './FullScreenWrapper'
import { useScreen } from '../contexts/screen.provider'

const InterviewScore = () => {
    const { isDesktop } = useScreen()
    return (
        <div className="w-full overflow-hidden  h-screen overflow-x-hidden  custom-scrollbar bg-white dark:bg-[#202020] flex flex-col ">
            <main className="flex gap-2  tablet:px-4 px-0   w-full   flex-col items-center tablet:items-start justify-stretch  tablet:flex-row flex-grow relative">
                {isDesktop && <GoogleAd />}
                <FullScreenWrapper>
                    <InterviewScoresPage />
                </FullScreenWrapper>
                {isDesktop && <GoogleAd />}
            </main>
        </div>
    )
}

export default InterviewScore